import React, { Component } from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts/highstock';
import { RESOLUTIONS } from 'services/config';
import { DataCenterApi } from 'services/datacenter';
import * as ReactDOMServer from 'react-dom/server';
import { CustomToolTip } from '../../styled_components/Common/CustomToolTip';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const LeftArrow = `${CDN_URL}common/down-arrow-hover.svg`;

class BarLineGraph extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			page: 1,
			lineData: null,
			sideAData: null,
			sideBData: null,
			categories: null,
			chart: null,
		};
	}

	getGraphSize = breakpoint => {
		let width = 620;
		let height = 300;

		let scrollBarHeight = 25;

		if (breakpoint === RESOLUTIONS.MED) {
			width = 925;
			height = 420;

			scrollBarHeight = 30;
		} else if (breakpoint === RESOLUTIONS.HIGH) {
			width = 1525;
			height = 650;

			scrollBarHeight = 30;
		}

		return { width, height, scrollBarHeight };
	};

	createChart = () => {
		const { breakpoint } = this.props;
		const { lineData, sideAData, sideBData, categories } = this.state;
		const { width, height, scrollBarHeight } = this.getGraphSize(breakpoint);

		Highcharts.AST.allowedAttributes.push('viewBox');
		const chart = Highcharts.chart('new-container', {
			chart: {
				width,
				height,
				type: 'column',
				backgroundColor: '#edefef',
				events: {
					redraw: e => {
						const { page } = this.state;
						const scrolled = e.target.scrollbar.scrollbarLeft;
						if (scrolled / page > 70) {
							this.setState(prevState => ({ page: prevState.page + 1 }), this.getPowerGraphData());
						}
					},
				},
			},
			title: {
				text: '',
				align: 'left',
			},
			xAxis: {
				max: 5,
				categories,
				gridLineWidth: 0,
				gridLineColor: 'red',
			},
			yAxis: {
				min: 0,
				title: {
					text: '',
				},
				gridLineWidth: 0,
				stackLabels: {
					enabled: false,
				},
			},
			scrollbar: {
				enabled: true,
				trackBackgroundColor: '#edefef',
				trackBorderColor: '#edefef',
				barBorderWidth: 0,
				barBackgroundColor: '#edefef',
				barBorderColor: '#edefef',
				rifleColor: '#edefef',
				buttonBorderRadius: '20',
				buttonBackgroundColor: '#edefef',
				buttonBorderColor: '#edefef',
				height: scrollBarHeight,
				buttonArrowColor: '#edefef',
			},
			legend: {
				enabled: false,
			},

			tooltip: {
				outside: false,
				useHTML: true,
				className: 'highcharts-tooltip-custom',

				formatter() {
					const point = this.point;
					let linePointValue = null;
					let sideAValue = null;
					let sideBValue = null;

					lineData.forEach(d => {
						if (d[0] === point.category) {
							linePointValue = d[1];
						}
					});
					sideAData.forEach(a => {
						if (a[0] === point.category) {
							sideAValue = a[1];
						}
					});
					sideBData.forEach(b => {
						if (b[0] === point.category) {
							sideBValue = b[1];
						}
					});

					return ReactDOMServer.renderToStaticMarkup(
						<CustomToolTip
							value1={linePointValue}
							value2={sideAValue}
							value3={sideBValue}
							unit='kWh'
							value2Label='Side A'
							value3Label='Side B'
							bottomText={`as of ${point.category}`}
						/>,
					);
				},
			},
			plotOptions: {
				column: {
					stacking: 'normal',
					borderRadius: 10,
					borderColor: '#edefef',
					borderWidth: 6,
					pointWidth: 15,
					label: {
						enabled: false,
					},
					dataLabels: {
						enabled: false,
					},
				},
			},
			series: [
				{
					name: 'A Side',
					data: sideAData,
					color: '#4AC489',
					enableMouseTracking: false,
					dataLabels: { enabled: false },
					opacity: 0.8,
				},
				{
					name: 'B Side',
					data: sideBData,
					color: '#00AD5C',
					enableMouseTracking: false,
					dataLabels: { enabled: false },
				},
				{
					cursor: 'pointer',
					name: 'Line Value',
					type: 'spline',
					data: lineData,
					color: '#00ad5c',
					marker: { enabled: false },
					dataLabels: { enabled: false },
					tooltip: {
						valueSuffix: 'Kwh',
					},
				},
			],
		});
		this.setState({ chart });
	};

	getPowerGraphDataInitial = () => {
		const { orgId, resolution } = this.props;

		const resolutionLower = resolution && resolution.toLowerCase();
		DataCenterApi.getPowerGraphData(orgId, resolutionLower, 1)
			.then(response => {
				const { lineData, sideAData, sideBData, categories, page: pageReturned } = response.data;

				this.setState({ lineData, sideAData, sideBData, categories, page: pageReturned + 1 }, () =>
					this.createChart(),
				);
			})
			.catch(() => {});
	};

	getPowerGraphData = () => {
		const { orgId, resolution } = this.props;
		const { page, chart } = this.state;
		const resolutionLower = resolution && resolution.toLowerCase();

		DataCenterApi.getPowerGraphData(orgId, resolutionLower, page)
			.then(response => {
				const { categories } = this.state;
				const {
					lineData: newlineData,
					sideAData: newsideAData,
					sideBData: newsideBData,
					categories: newcategories,
				} = response.data;
				categories.push(...newcategories);
				//seriesA
				newsideAData.forEach(point => {
					chart.series[0].addPoint(point);
				});
				//seriesB
				newsideBData.forEach(point => {
					chart.series[1].addPoint(point);
				});
				//line
				newlineData.forEach(point => {
					chart.series[2].addPoint(point);
				});

				chart.xAxis[0].setCategories(categories);
			})
			.catch(() => {});
	};
	componentDidMount() {
		this.getPowerGraphDataInitial();
	}
	componentDidUpdate(prevProps) {
		const { resolution, breakpoint } = this.props;
		if (resolution !== prevProps.resolution || breakpoint !== prevProps.breakpoint) {
			this.setState({ page: 1 }, this.getPowerGraphDataInitial());
		}
	}

	render() {
		const { id, cypressId } = this.props;

		return (
			<div id={id} data-cy={cypressId} className='bar-line-graph'>
				<div className='new-container' id='new-container'></div>
				<img className='left-arrow' src={LeftArrow}></img>
				<img className='right-arrow' src={LeftArrow}></img>
			</div>
		);
	}
}
function mapStateToProps(state) {
	return {
		auth_status: state.auth_status,
	};
}
export default connect(mapStateToProps, null)(BarLineGraph);
